import { action } from 'satcheljs';
import type { SuggestionKind } from 'owa-search-service';
import type { AssetSearchRequest, AssetSearchResponse } from 'owa-timestream-asset-search';

/**
 * Sends multiple search queries simultaneously and batches the results together. Each query
 * will fan out to hit all registered searchable assets
 */
export const invokeTimestreamSearch = action(
    'invokeTimestreamSearch',
    (actionSource: string, requests: AssetSearchRequest[]) => ({
        actionSource,
        requests,
    })
);

/**
 * Invoke suggestions for timestream
 */
export const invokeTimestreamSuggestions = action(
    'invokeTimestreamSuggestions',
    (queryStringForSuggestions: string, supportedSuggestions: SuggestionKind[]) => ({
        queryStringForSuggestions,
        supportedSuggestions,
    })
);

/**
 * Triggers an action indicating search query is complete, so the results can be processed.
 * This will fire for each registered searchable asset separately, and may fire multiple times for
 * each if there are multiple calls necessary to fetch all the data.
 */
export const timestreamSearchCompleted = action(
    'timestreamSearchCompleted',
    (searchResponse?: AssetSearchResponse, error?: string, searchRequest?: AssetSearchRequest) => ({
        searchResponse,
        error,
        searchRequest,
    })
);
